import { QUESTIONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'

const version_media_request = () => {
  return {
    type: questionsTypes.version_media.request
  }
}

const version_media_success = (response) => {
  return {
    type: questionsTypes.version_media.success,
    payload: response.data
  }
}

const version_media_failure = (messages) => {
  return {
    type: questionsTypes.version_media.failure,
    payload: messages
  }
}

const version_audio = (question_id, version_id=null) => {
  return function (dispatch) {
    // Before Request
    dispatch(version_media_request())
    const version_tag = version_id === null ? '' : `?version=${version_id}`
    // Request
    axios({
      method: 'get',
      url: `${formatRoute(QUESTIONS_ROUTES.audio, {id: question_id})}${version_tag}`,
      responseType: 'blob'
    }).then( response => {
      // success
      dispatch( version_media_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error downloading audio."]
      }
      // dispatch( try_force_logoff(error.response) )
      // window.showSnackbar('error', errors)
      dispatch( version_media_failure(errors))
    })
  }
}

const version_image = (question_id, version_id=null) => {
  return function (dispatch) {
    // Before Request
    dispatch(version_media_request())
    const version_tag = version_id === null ? '' : `?version=${version_id}`
    // Request
    axios({
      method: 'get',
      url: `${formatRoute(QUESTIONS_ROUTES.image, {id: question_id})}${version_tag}`,
      responseType: 'blob'
    }).then( response => {
      // success
      dispatch( version_media_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error downloading image."]
      }
      // dispatch( try_force_logoff(error.response) )
      // window.showSnackbar('error', errors)
      dispatch( version_media_failure(errors))
    })
  }
}

function report_image(question_id, version_id){
  const version_tag = version_id === null ? '' : `?version=${version_id}`
  return axios({
    method: 'get',
    url: `${formatRoute(QUESTIONS_ROUTES.image, {id: question_id})}${version_tag}`,
    responseType: 'blob'
  }).then( response => {
    return response.data
  }).catch( error => {
    return false
  })
}

export {
  version_audio,
  version_image,
  version_media_request,
  report_image
}



// WEBPACK FOOTER //
// ./src/js/actions/questions/get_version_media.js